/* beautiful-react-hooks version: 0.31.1 */
import useGlobalEvent from './useGlobalEvent.js';

var useWindowResize = function useWindowResize(handler) {
  return useGlobalEvent('resize', null, handler);
};

export default useWindowResize;
